<template>
  <span class="iconfont" :class="iconTag" :style="iconStyle" />
</template>

<script>
import '../../assets/iconfont/iconfont.css';
export default {
  props: {
    iconClass: {
      type: String,
      required: true
    },
    iconSize: {
      type: [String, Number],
      default: 12
    },
    iconColor: {
      type: String,
      default: 'fff'
    }
  },
  computed: {
    iconTag() {
      return `icon-${this.iconClass}`;
    },
    iconStyle() {
      return {
        color: '#' + this.iconColor,
        fontSize: this.iconSize + 'px'
      };
    }
  }
};
</script>

<style scoped>
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 12px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
